import { z } from 'zod';
export const DSLRangeQueryDTO = z.object({
  range: z.record(
    z.string(),
    z.object({
      gte: z.union([z.string(), z.number()]).optional(),
      lte: z.union([z.string(), z.number()]).optional(),
      gt: z.union([z.string(), z.number()]).optional(),
      lt: z.union([z.string(), z.number()]).optional(),
      boost: z.number().optional(),
    }),
  ),
});

export type DSLRangeQuery = z.infer<typeof DSLRangeQueryDTO>;